import React from "react";
import loaderGif from "../../Assets/Images/Loader.gif";

const PageLoader = () => {
  return (
    <div className="fixed inset-0 z-[1000] grid place-items-center bg-black backdrop-blur-sm">
      <img
        src={loaderGif}
        alt="Loading"
        className="w-32 h-32 md:w-full md:h-full object-cover"
      />
    </div>
  );
};

export default PageLoader;
